<template>
  <div class="transaction-detail">
    <BlNavBarMv
      has-back-button
      title="Detail transaksi"
      class="navbar"
      @handleBackButtonClick="$emit('back')"
    />
    <div v-if="isLoading" data-testid="shimmer">
      <div class="bg-white mb-12 p-16">
        <BlShimmerAv width="100%" height="21px" />
      </div>
      <div class="bg-white mb-12 p-16">
        <BlShimmerAv width="100%" height="88px" />
      </div>
      <div class="bg-white mb-12 p-16">
        <BlShimmerAv width="100%" height="330px" />
      </div>
    </div>
    <div
      v-else-if="isLoaded && transaction"
      data-testid="transaction-detail-content"
    >
      <div
        v-if="showReturnInfo && transaction.notes"
        class="bg-white"
        style="padding: 20px; padding-bottom: 0;"
      >
        <bl-banner-mv variation="warning">
          {{ transaction.notes }}
        </bl-banner-mv>
      </div>
      <BlFlexContainerMv
        justify-content="space-between"
        class="p-16 mb-12 bg-white"
      >
        <BlTextAv variation="body-16" weight="bold">
          Status
        </BlTextAv>
        <BlCapsuleAv :variation="statusVariation">
          {{ humanizedTransactionStatus }}
        </BlCapsuleAv>
      </BlFlexContainerMv>

      <div class="transaction__item p-16 bg-white">
        <BlTextAv variation="body-16" weight="bold">
          Pesan Alat ATM Mitra
        </BlTextAv>
        <BlFlexContainerMv v-if="item" class="mt-16">
          <BlFlexItemAv basis="48px" class="mr-8">
            <img :src="item.image_urls[0]" class="item-img" />
          </BlFlexItemAv>
          <BlFlexItemAv :grow="1" :shrink="1">
            <BlTextAv color="subdued">
              Pesan Alat ATM Mitra
            </BlTextAv>
            <BlTextAv class="mt-4">
              {{ item.name }}
            </BlTextAv>
          </BlFlexItemAv>
        </BlFlexContainerMv>
        <BlButtonAv
          fullwidth
          class="mt-12"
          @click="handleViewTransactionReceipt"
        >
          Lihat bukti transaksi
        </BlButtonAv>
      </div>

      <BlAccordionMv :is-active="true" class="bg-white mt-12">
        <template v-slot:header>
          <BlTextAv variation="body-16" weight="bold">
            Info transaksi
          </BlTextAv>
        </template>
        <template v-slot:content>
          <div v-for="info in paymentSchemaDetail" :key="info.label">
            <div>
              <BlTextAv variation="caption-12" class="mb-4">
                {{ info.label }}
              </BlTextAv>
              <BlTextAv>{{ info.value }}</BlTextAv>
            </div>
            <BlSeparatorAv style="margin: 16px -16px" />
          </div>
          <div>
            <BlTextAv variation="caption-12" class="mb-4">
              Alamat pengiriman
            </BlTextAv>
            <BlTextAv>{{ fullAddress }}</BlTextAv>
          </div>
        </template>
      </BlAccordionMv>

      <BlAccordionMv
        v-if="shouldShowDetailPayment"
        :is-active="true"
        class="bg-white mt-12"
      >
        <template v-slot:header>
          <BlTextAv variation="body-16" weight="bold">
            Detail pembayaran
          </BlTextAv>
        </template>
        <template v-slot:content>
          <div>
            <BlTextAv variation="caption-12" class="mb-4">
              Nomor Pesanan
            </BlTextAv>
            <BlFlexContainerMv
              align-items="center"
              justify-content="space-between"
            >
              <BlFlexItemAv>
                <BlTextAv>
                  {{ transaction.invoice_group_number }}
                </BlTextAv>
              </BlFlexItemAv>
              <BlFlexItemAv>
                <BlLinkAv variation="dark" @click="copyInvoiceCode">
                  Salin
                </BlLinkAv>
              </BlFlexItemAv>
            </BlFlexContainerMv>
            <BlSeparatorAv style="margin: 16px -16px" />
          </div>
          <div>
            <BlTextAv variation="caption-12" class="mb-4">
              Tanggal Pembayaran
            </BlTextAv>
            <BlTextAv>{{ displayDate }}</BlTextAv>
            <BlSeparatorAv style="margin: 16px -16px" />
          </div>
          <div>
            <BlTextAv variation="caption-12" class="mb-4">
              Total Bayar
            </BlTextAv>
            <BlFlexContainerMv
              align-items="center"
              justify-content="space-between"
            >
              <BlFlexItemAv>
                <BlTextAv> {{ money(totalAmount) }}</BlTextAv>
              </BlFlexItemAv>
              <BlFlexItemAv>
                <BlLinkAv variation="primary" @click="toggleShowPriceDetail">
                  {{ priceDetailBtnText }}
                </BlLinkAv>
              </BlFlexItemAv>
            </BlFlexContainerMv>
            <transition name="slide-down">
              <div v-if="showPriceDetail">
                <BlFlexContainerMv
                  class="mt-12"
                  align-items="center"
                  justify-content="space-between"
                >
                  <BlFlexItemAv>
                    <BlTextAv>{{ paymentSchemaDetail[0].value }}</BlTextAv>
                  </BlFlexItemAv>
                  <BlFlexItemAv>
                    <BlTextAv>{{ money(transaction.amount) }}</BlTextAv>
                  </BlFlexItemAv>
                </BlFlexContainerMv>
                <BlFlexContainerMv
                  class="mt-12"
                  align-items="center"
                  justify-content="space-between"
                >
                  <BlFlexItemAv>
                    <BlTextAv>Biaya pengiriman</BlTextAv>
                  </BlFlexItemAv>
                  <BlFlexItemAv>
                    <BlTextAv v-if="shouldShowDeliveryFee">
                      {{ money(transaction.delivery_fee) }}
                    </BlTextAv>
                    <BlTextAv v-else color="success-02">
                      Gratis
                    </BlTextAv>
                  </BlFlexItemAv>
                </BlFlexContainerMv>
                <BlFlexContainerMv
                  v-if="Number(transaction.voucher_amount) > 0"
                  class="mt-12"
                  align-items="center"
                  justify-content="space-between"
                >
                  <BlFlexItemAv>
                    <BlTextAv>Promo</BlTextAv>
                  </BlFlexItemAv>
                  <BlFlexItemAv>
                    <BlTextAv>
                      {{ money(-transaction.voucher_amount) }}
                    </BlTextAv>
                  </BlFlexItemAv>
                </BlFlexContainerMv>
              </div>
            </transition>
            <BlSeparatorAv style="margin: 16px -16px" />
          </div>
          <div v-if="transaction.device_serial_number">
            <BlTextAv variation="caption-12" class="mb-4">
              Nomor Seri
            </BlTextAv>
            <BlFlexContainerMv
              align-items="center"
              justify-content="space-between"
            >
              <BlFlexItemAv>
                <BlTextAv>
                  {{ transaction.device_serial_number }}
                </BlTextAv>
              </BlFlexItemAv>
              <BlFlexItemAv>
                <BlLinkAv variation="dark" @click="copySerialNumber">
                  Salin
                </BlLinkAv>
              </BlFlexItemAv>
            </BlFlexContainerMv>
            <BlSeparatorAv style="margin: 16px -16px" />
          </div>
          <div>
            <BlTextAv variation="caption-12" class="mb-4">
              Metode Pembayaran
            </BlTextAv>
            <BlTextAv> {{ displayPaymentMethod }}</BlTextAv>
          </div>
        </template>
      </BlAccordionMv>

      <div class="p-16 bg-white mt-12">
        <BlFlexContainerMv
          class="cs-footer p-12"
          @click.native="handleHelpClick"
        >
          <BlFlexItemAv basis="48px">
            <img
              :src="require('../images/img_small_logo_whatsapp.png')"
              loading="lazy"
            />
          </BlFlexItemAv>
          <BlFlexItemAv :shrink="1">
            <BlTextAv variation="body-16" weight="bold" class="mb-4">
              Butuh Bantuan?
            </BlTextAv>
            <BlTextAv variation="caption-12" color="secondary">
              Hubungi WhatsApp kami, melayani online 24/7.
            </BlTextAv>
          </BlFlexItemAv>
          <BlFlexItemAv basis="20px">
            <IcoChevronRightMinor />
          </BlFlexItemAv>
        </BlFlexContainerMv>
      </div>
    </div>
    <div v-else-if="isError" class="error-section">
      <BlTextAv class="mb-8">
        Terjadi kesalahan. Silakan coba lagi.
      </BlTextAv>
      <BlButtonAv
        size="extra-small"
        data-testid="retry-button"
        @click="initialize"
      >
        Muat ulang
      </BlButtonAv>
    </div>
    <BlSnackbarMv :message="snackbarValue" :active.sync="showSnackbar" />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import {
  BlFlexContainerMv,
  BlFlexItemAv,
  BlAccordionMv,
  BlNavBarMv,
  BlShimmerAv,
  BlCapsuleAv,
  BlSeparatorAv,
  BlButtonAv,
  BlTextAv,
  BlLinkAv,
  BlSnackbarMv,
  BlBannerMv,
} from '@bukalapak/bazaar-mweb';
import IcoChevronRightMinor from '@bukalapak/bazaar-visual-v1/dist/components/IcoChevronRightMinor';
import exclusiveNeoApi from 'shared_js/api/exclusiveApi/exclusiveNeoApi';
import money from 'shared_js/helpers/stringHelper/money';
import humanizeTimestamp from 'shared_js/helpers/dateHelper/humanizeTimestamp';
import { receiptBuilder } from 'shared_js/modules/receipt-builder';
import STATUS_MAP from '../constants/statusMap';

function getPrice(amount) {
  if (!amount) return undefined;
  return money(amount);
}

const TRACKER_SCREEN_NAME = 'mitra-item-trx-detail-';

export default {
  name: 'TransactionDetailPage',
  components: {
    BlNavBarMv,
    BlFlexContainerMv,
    BlFlexItemAv,
    BlAccordionMv,
    BlShimmerAv,
    BlCapsuleAv,
    BlSeparatorAv,
    BlButtonAv,
    BlTextAv,
    IcoChevronRightMinor,
    BlLinkAv,
    BlSnackbarMv,
    BlBannerMv,
  },
  data() {
    return {
      item: undefined,
      paymentScheme: {},
      showPriceDetail: false,
      showSnackbar: false,
      snackbarValue: '',
      userAgentProfile: undefined,
    };
  },
  computed: {
    ...mapGetters('mitraItems', ['isLoading', 'isLoaded', 'isError']),
    transaction() {
      if (!this.item) return undefined;
      return this.item.transaction;
    },
    statusVariation() {
      if (this.transaction?.status === 'success') return 'success';
      if (this.transaction?.status === 'rejected') return 'critical';
      if (this.transaction?.status === 'on-delivery') return 'warning';
      return 'secondary';
    },
    humanizedTransactionStatus() {
      return STATUS_MAP[this.transaction?.status] ?? this.transaction?.status;
    },
    paymentSchemaDetail() {
      if (!this.paymentScheme.id) return [];
      return [
        {
          label: 'Schema yang dipilih',
          value: this.paymentScheme.title,
        },
        {
          label: 'Bayar penuh',
          value: getPrice(this.paymentScheme.full_payment_amount),
        },
        {
          label: 'Deposit',
          value: getPrice(this.paymentScheme.deposit_amount),
        },
        {
          label: 'Biaya sewa',
          value: getPrice(this.paymentScheme.rent_fee_amount),
        },
        {
          label: 'Biaya harian',
          value: getPrice(this.paymentScheme.daily_fee_amount),
        },
        {
          label: 'Biaya bulanan',
          value: getPrice(this.paymentScheme.monthly_fee_amount),
        },
      ].filter(data => data.value);
    },
    fullAddress() {
      if (!this.transaction?.address) return '';
      const {
        address,
        rt,
        rw,
        district,
        city,
        province,
        postal_code: postalCode,
      } = this.transaction;
      let text = `${address}, RT ${rt} / RW ${rw}, ${district}, ${city}, ${province}`;
      if (postalCode) text += `, ${postalCode}`;
      return text;
    },
    priceDetailBtnText() {
      if (this.showPriceDetail) {
        return 'Tutup';
      }

      return 'Lihat rincian';
    },
    displayDate() {
      const format = '%d% %month% %yyyy%, %hh%:%mi%';
      return humanizeTimestamp(new Date(this.transaction.paid_at), format);
    },
    displayPaymentMethod() {
      switch (this.transaction.payment_method) {
        case 'dana':
          return 'DANA';
        default:
          return 'Saldo Mitra';
      }
    },
    shouldShowDeliveryFee() {
      return Number(this.transaction.delivery_fee) !== 0;
    },
    totalAmount() {
      return (
        Number(this.transaction.amount) +
        Number(this.transaction.delivery_fee || 0) -
        Number(this.transaction.voucher_amount || 0)
      );
    },
    tncUrl() {
      return this.item?.tnc_url;
    },
    showReturnInfo() {
      return this.transaction?.status === 'rejected';
    },
    shouldShowDetailPayment() {
      return this.transaction.purchase_method === 'auto';
    },
  },
  mounted() {
    this.initialize();
  },
  methods: {
    ...mapActions('mitraItems', [
      'retrieveMitraItemTransactionById',
      'retrieveUserAgentProfile',
    ]),
    money,
    async initialize() {
      const id = Number(this.$route.params.id);
      const [item, userAgentProfile] = await Promise.all([
        this.retrieveMitraItemTransactionById({ id }),
        this.retrieveUserAgentProfile(),
      ]);
      this.item = item;
      this.userAgentProfile = userAgentProfile;
      if (!this.item?.transaction) {
        this.$router.replace({ name: 'LandingPage' });
        return;
      }
      this.visitScreenTrack();
      await this.fetchPaymentScheme();
    },
    async fetchPaymentScheme() {
      const key = 'mitra-items/payment-schemes';
      const { data } = await exclusiveNeoApi.retrieveNeoConfig([key]);
      const itemSchemes =
        data?.[0]?.data?.payment_schemes[this.transaction.mitra_item_id] ?? [];
      this.paymentScheme =
        itemSchemes.find(
          scheme => scheme.id === this.transaction.schema_type,
        ) ?? {};
    },
    openWhatsapp() {
      window.open('https://wa.me/628175720770', '_blank');
    },
    handleHelpClick() {
      this.trackHelpClick();
      this.openWhatsapp();
    },
    trackHelpClick() {
      if (this.$tracker) {
        this.$tracker.itemMitraItemClickTrack({
          click_source: 'click-butuh-bantuan',
          current_screen: `${TRACKER_SCREEN_NAME}${this.transaction.mitra_item_id}`,
          target_screen: 'whatsapp_support',
        });
      }
    },
    toggleShowPriceDetail() {
      this.showPriceDetail = !this.showPriceDetail;
    },
    copyToClipboard(value, successMessage) {
      const $tempInput = document.createElement('input');
      document.body.appendChild($tempInput);
      $tempInput.value = value;
      $tempInput.select();
      document.execCommand('copy');
      $tempInput.remove();
      this.onSnackbarShow(successMessage);
    },
    copyInvoiceCode() {
      this.copyToClipboard(
        this.transaction.invoice_group_number,
        'Nomor pesanan berhasil disalin',
      );
    },
    copySerialNumber() {
      this.copyToClipboard(
        this.transaction.device_serial_number,
        'Nomor seri berhasil disalin',
      );
    },
    onSnackbarShow(message) {
      this.snackbarValue = message;
      this.showSnackbar = true;
    },
    visitScreenTrack() {
      if (this.$tracker) {
        this.$tracker.itemMitraLandingPageVisitTrack({
          current_screen: `${TRACKER_SCREEN_NAME}${this.transaction.mitra_item_id}`,
        });
      }
    },
    handleTncClick() {
      this.trackTncClick();
      if (this.tncUrl) {
        window.location.assign(this.tncUrl);
      }
    },
    trackTncClick() {
      if (this.$tracker) {
        this.$tracker.itemMitraItemClickTrack({
          click_source: 'click-wilayah-pengiriman',
          current_screen: `${TRACKER_SCREEN_NAME}${this.transaction.mitra_item_id}`,
          target_screen: 'tnc_page',
        });
      }
    },
    handleViewTransactionReceipt() {
      if (this.$tracker) {
        this.$tracker.itemMitraItemClickTrack({
          click_source: 'click-lihat-bukti-transaksi',
          current_screen: `${TRACKER_SCREEN_NAME}${this.transaction.mitra_item_id}`,
          target_screen: 'transaction_receipt',
        });
      }
      console.log('this.transaction', this.transaction);
      this.openReceipt();
    },
    openReceipt() {
      const receiptItems = [
        receiptBuilder.createColumn(
          'TGL TRANSAKSI',
          `${humanizeTimestamp(
            this.transaction.created_at,
            '%d% %mmm% %yyyy%',
          )}\n${humanizeTimestamp(this.transaction.created_at, '%hh%:%mi%')}`,
        ),
        receiptBuilder.createDivider(),
        receiptBuilder.createColumn(
          'NO. PESANAN',
          this.transaction.invoice_group_number,
        ),
        receiptBuilder.createColumn(
          'HARGA PRODUK',
          money(this.transaction.amount),
        ),
        receiptBuilder.createColumn(
          'BIAYA PENGIRIMAN',
          money(this.transaction.delivery_fee),
        ),
        ...(Number(this.transaction.voucher_amount) > 0
          ? [
              receiptBuilder.createColumn(
                'PROMO',
                money(-this.transaction.voucher_amount),
              ),
            ]
          : []),
      ];
      const receiptData = {
        receiptData: {
          contentItems: receiptItems,
          isBookkeeping: false,
          isBukasend: false,
          isDebt: false,
          isPaymentRequest: false,
          productName: this.transaction.transaction_name,
          storeName: this.userAgentProfile?.name || '',
        },
        billDetail: [],
        receiptNote: [
          receiptBuilder.createSpace(),
          receiptBuilder.createNote(
            'Harap simpan struk ini sebagai tanda bukti pembayaran yang sah.',
          ),
        ],
        receiptType: 'type_normal',
        sellingPrice: this.totalAmount,
        invoiceNumber: this.transaction.invoice_group_number,
        productDetail: {},
        referrerName: this.productCategory,
      };
      if (window?.blandroid?.printReceipt) {
        window.blandroid.printReceipt(JSON.stringify(receiptData));
      } else {
        console.log(JSON.stringify(receiptData, null, 2)); // eslint-disable-line no-console
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.transaction-detail {
  padding-top: 56px;
  background: #f2f2f2;
  min-height: 100svh;

  &.is-loading {
    background: #fff;
  }

  ::v-deep .bl-shimmer {
    border-radius: 4px;
    display: block;
  }
}

.item-img {
  max-width: 48px;
  height: auto;
  border-radius: 4px;
  border: 1px solid #ebebeb;
}

.navbar {
  border-bottom: 1px solid #ebebeb;
  position: fixed;
  top: 0;
  z-index: 999;
  width: 100%;
}

.cs-footer {
  background: #ddf6dd;
  border-radius: 8px;
  align-items: center;
  justify-content: center;
  gap: 16px;
}
</style>
